<mat-button-toggle-group class="mat-button-toggle-group--in-fixed-top">
  <mat-button-toggle
    (click)="openTab($event, tabsEnum.ACTIVE)"
    [ngClass]="{ active: (stateEnabled$ | async)!(tabsEnum.ACTIVE) }"
    data-cy="customer-users-tab-active">
    {{ ("active" | i18n) || "active" | titlecase }}
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="createdUsersCount$ | async"
    (click)="openTab($event, tabsEnum.CREATED)"
    [ngClass]="{ active: (stateEnabled$ | async)!(tabsEnum.CREATED) }"
    data-cy="customer-users-tab-created">
    <span
      matBadgeOverlap="false"
      [matBadgeHidden]="(createdUsersCount$ | async) == 0"
      [matBadge]="createdUsersCount$ | async"
      data-cy="customer-users-tab-created-count">
      {{ ("created" | i18n) || "created" | titlecase }}
    </span>
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="requestedUsersCount$ | async"
    (click)="openTab($event, tabsEnum.INVITED)"
    [ngClass]="{ active: (stateEnabled$ | async)!(tabsEnum.INVITED) }"
    data-cy="customer-users-tab-invited">
    <span
      matBadgeOverlap="false"
      [matBadgeHidden]="!(requestedUsersCount$ | async)"
      [matBadge]="requestedUsersCount$ | async"
      data-cy="customer-users-tab-invited-count">
      {{ ("invited" | i18n) || "invited" | titlecase }}
    </span>
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="registeredUsersCount$ | async"
    (click)="openTab($event, tabsEnum.REGISTERED)"
    [ngClass]="{ active: (stateEnabled$ | async)!(tabsEnum.REGISTERED) }"
    data-cy="customer-users-tab-registered">
    <span
      matBadgeOverlap="false"
      [matBadgeHidden]="!(registeredUsersCount$ | async)"
      [matBadge]="registeredUsersCount$ | async"
      data-cy="customer-users-tab-registered-count">
      {{ ("registered" | i18n) || "registered" | titlecase }}
    </span>
  </mat-button-toggle>
  <mat-button-toggle
    *ngIf="formerUsersCount$ | async"
    (click)="openTab($event, tabsEnum.FORMER)"
    [ngClass]="{ active: (stateEnabled$ | async)!(tabsEnum.FORMER) }"
    data-cy="customer-users-tab-former">
    <span
      matBadgeOverlap="false"
      [matBadgeHidden]="(formerUsersCount$ | async) == 0"
      [matBadge]="formerUsersCount$ | async"
      data-cy="customer-users-tab-former-count">
      {{ ("former" | i18n) || "former" | titlecase }}
    </span>
  </mat-button-toggle>
</mat-button-toggle-group>
<div class="row filter-bar">
  <div
    class="col-md-12"
    *ngIf="hasChipSelection$ | async">
    <mat-chip-list multiple>
      <mat-chip
        [selected]="(roleFilterEnabled$ | async)!(roleEnum.POOL)"
        (click)="filterRole($event, roleEnum.POOL)"
        [attr.data-cy]="'roleFilter-pooler-button'">
        {{ "roleEnum." + roleEnum.POOL | i18n }} ({{
          poolerUserCounts$ | async
        }})
      </mat-chip>
      <mat-chip
        *ngIf="permissionsService.canReadDispoUsers$ | async"
        [selected]="(roleFilterEnabled$ | async)!(roleEnum.DISPO)"
        (click)="filterRole($event, roleEnum.DISPO)"
        [attr.data-cy]="'roleFilter-disponent-button'">
        {{ "roleEnum." + roleEnum.DISPO | i18n }} ({{
          dispoUserCounts$ | async
        }})
      </mat-chip>
      <mat-chip
        *ngIf="
          (permissionsService.canReadRequesterUsers$ | async) &&
          (customer$ | async)?.enableJobRequestProcess
        "
        [selected]="(roleFilterEnabled$ | async)!(roleEnum.REQUESTER)"
        (click)="filterRole($event, roleEnum.REQUESTER)"
        [attr.data-cy]="'roleFilter-requester-button'">
        {{ "roleEnum." + roleEnum.REQUESTER | i18n }}
        ({{ requesterUserCounts$ | async }})
      </mat-chip>
    </mat-chip-list>
  </div>
  <div class="col-md-12">
    <app-text-search
      class="filter-bar"
      [useQueryParam]="'search'"
      (searchTextChanged)="search($event)">
    </app-text-search>
    <app-department-select
      *ngIf="selectedDepartmentIds$ | async as selectedDepartmentIds"
      (departmentsSelectionChanged)="selectDepartments($event || [])"
      [isMultiSelect]="true"
      [selectedDepartmentIds]="selectedDepartmentIds"></app-department-select>
  </div>
</div>
<div class="customer-users-list-wrapper">
  <div class="customer-users-list">
    <div class="customer-users-list__users-wrapper">
      <header class="customer-users-list-header">
        <div class="customer-users-list-header__content-wrapper">
          <div class="customer-users-list__attribute-name">
            {{ ("name" | i18n) || "name" | titlecase }}
          </div>
          <div *ngIf="(isLoading$ | async) || (loadingCollection$ | async)">
            <mat-spinner
              data-cy="customer-users-list-header-spinner"
              diameter="24"></mat-spinner>
          </div>
        </div>
      </header>
      <ng-container>
        <div
          class="noUser"
          *ngIf="
            (users$ | async)?.length == 0 &&
            !(isLoading$ | async) &&
            !(loadingCollection$ | async)
          ">
          {{ ("noUsersFound" | i18n) || "No users found" }}
        </div>
        <ng-container
          *ngFor="
            let user of users$ | async;
            trackBy: trackUser;
            let i = index
          ">
          <app-customer-users-list-item
            *ngIf="!(usersLimit$ | async) || i < ((usersLimit$ | async) || 0)"
            [user]="user"></app-customer-users-list-item>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<div
  *ngIf="usersLimited$ | async"
  class="users-count-notice">
  <mat-icon svgIcon="information-outline"></mat-icon>
  {{
    ('notShowingAllUsers' | i18n: { count: (usersLimit$ | async) }) ||
      ("Es werden nur {{count}}
  Mitarbeiter dargestellt. Nutze das Suchfeld um andere Mitarbeiter zu sehen." |
  i18n: { count: (usersLimit$ | async) }) }}
  <button
    mat-button
    (click)="loadAllUsers()">
    {{ ("loadAll" | i18n) || "Alle Laden" | uppercase }}
  </button>
</div>

<div class="a-fixed-action-bar a-fixed-action-bar--fixed-bottom">
  <button
    *ngIf="
      (permissionsService.canCreatePoolerUsers$ | async) ||
      (permissionsService.canCreateDispoUsers$ | async) ||
      (permissionsService.canCreateRequesterUsers$ | async)
    "
    class="mat-fab mat-fab--extended mat-elevation-z8"
    (click)="openAddUserDialog()"
    data-cy="add-pooler-button">
    <mat-icon svgIcon="account-plus"></mat-icon>
    <span class="mat-fab__label">{{
      ("add" | i18n) || "add" | uppercase
    }}</span>
  </button>
</div>
